import { NavRow } from "./NavRow";
import { TAIL_ITEMS } from "./navItems";
import { useT } from "../../shared/i18n";

/**
 * Print / Export / Trash rows shared by the tablet rail and desktop sidebar
 * (spec §7). Export stays a download link; the others navigate.
 */
export function TailRows({
  showLabel,
  tooltip,
  onNavigate,
}: {
  showLabel: boolean;
  tooltip: boolean;
  onNavigate: (path: string) => void;
}) {
  const t = useT();
  return (
    <>
      {TAIL_ITEMS.map(({ key, path, href, labelKey, icon }) => (
        <NavRow
          key={key}
          icon={icon}
          label={t(labelKey)}
          orientation="horizontal"
          showLabel={showLabel}
          tooltip={tooltip}
          testId={`nav-tail-${key}`}
          href={href}
          onClick={path ? () => onNavigate(path) : undefined}
        />
      ))}
    </>
  );
}
